import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Schema } from './create/components/division-form.schema';
import { DivisionWriteRequest } from '~/apis/ssf';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreateDivisionMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ ...payload }: Schema) =>
      SSF.api.divisionsCreate({
        ...payload,
        series: payload.series[1],
      }),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}

export function useUpdateDivisionMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: DivisionWriteRequest }) =>
      SSF.api.divisionsUpdate(id, payload),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.all }),
  });
}

export function useDeleteDivisionMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.divisionsDestroy>[0]) => SSF.api.divisionsDestroy(variables),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}
